module.exports = __webpack_public_path__ + "static/media/curved0.ae4b6c43.jpg";